export default "__VITE_ASSET__C56rEisz__"